var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSpin = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#spin_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 1.667a.833.833 0 0 1 .833.833V5a.834.834 0 0 1-1.666 0V2.5A.833.833 0 0 1 10 1.667Zm0 12.5a.834.834 0 0 1 .833.833v2.5a.833.833 0 1 1-1.666 0V15a.833.833 0 0 1 .833-.833Zm7.217-8.334a.833.833 0 0 1-.305 1.139l-2.165 1.25a.833.833 0 1 1-.834-1.444l2.165-1.25a.834.834 0 0 1 1.139.305Zm-10.825 6.25a.833.833 0 0 1-.305 1.139l-2.165 1.25a.835.835 0 0 1-1.226-.938.833.833 0 0 1 .392-.506l2.165-1.25a.833.833 0 0 1 1.139.305Zm10.825 2.084a.833.833 0 0 1-1.139.305l-2.165-1.25a.834.834 0 0 1 .834-1.444l2.165 1.25a.833.833 0 0 1 .305 1.139ZM6.392 7.917a.833.833 0 0 1-1.139.305l-2.165-1.25a.833.833 0 1 1 .834-1.444l2.165 1.25a.833.833 0 0 1 .305 1.139Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "spin_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgSpin;